import { Component } from '@angular/core';

@Component({
    selector: 'fi-site-map-edit-content-drag-icon',
    template: '<li class="item-dnd"><mat-icon class="fi-icon-move"></mat-icon></li>',
    standalone: false,
})
export class SiteMapEditContentDragIconComponent {}
